export const INITIATE_COMPOSE_MESSAGE = 'communicator/INITIATE_COMPOSE_MESSAGE';
export const INITIATE_COMPOSE_MESSAGE_ENHANCED_RECIPIENTS = 'communicator/INITIATE_COMPOSE_MESSAGE_ENHANCED_RECIPIENTS';
export const END_COMPOSE_MESSAGE = 'communicator/END_COMPOSE_MESSAGE';
export const INITIATE_SCHEDULE_COMPOSE_MESSAGE = 'communicator/INITIATE_SCHEDULE_COMPOSE_MESSAGE';

export const CREATE_DRAFT_MESSAGE_REQUEST = 'communicator/CREATE_DRAFT_MESSAGE_REQUEST';
export const CREATE_DRAFT_MESSAGE_SUCCESS = 'communicator/CREATE_DRAFT_MESSAGE_SUCCESS';
export const CREATE_DRAFT_MESSAGE_FAILURE = 'communicator/CREATE_DRAFT_MESSAGE_FAILURE';

export const SCHEDULE_MESSAGE_REQUEST = 'communicator/SCHEDULE_MESSAGE_REQUEST';
export const SCHEDULE_MESSAGE_SUCCESS = 'communicator/SCHEDULE_MESSAGE_SUCCESS';
export const SCHEDULE_MESSAGE_FAILURE = 'communicator/SCHEDULE_MESSAGE_FAILURE';

export const SEND_MESSAGE_REQUEST = 'communicator/SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'communicator/SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'communicator/SEND_MESSAGE_FAILURE';

export const ADD_RECIPIENT_REQUEST = 'communicator/ADD_RECIPIENT_REQUEST';
export const ADD_RECIPIENT_SUCCESS = 'communicator/ADD_RECIPIENT_SUCCESS';
export const ADD_RECIPIENT_FAILURE = 'communicator/ADD_RECIPIENT_FAILURE';

export const ADD_ALL_RECIPIENTS = 'communicator/ADD_ALL_RECIPIENTS';
export const ADD_ALL_GROUPS = 'communicator/ADD_ALL_GROUPS';
export const ADD_ALL_OPTIONAL_GROUPS = 'communicator/ADD_ALL_OPTIONAL_GROUPS';
export const ADD_ALL_SAVED_SEARCHES = 'communicator/ADD_ALL_SAVED_SEARCHES';
export const ADD_ALL_OPTIONAL_SAVED_SEARCHES = 'communicator/ADD_ALL_OPTIONAL_SAVED_SEARCHES';
export const ADD_ALL_OPTIONAL_RECIPIENTS = 'communicator/ADD_ALL_OPTIONAL_RECIPIENTS';
export const ADD_ALL_SITES = 'communicator/ADD_ALL_SITES';
export const ADD_ALL_OPTIONAL_SITES = 'communicator/ADD_ALL_OPTIONAL_SITES';

export const ADD_ALL_ADDITIONAL_RECIPIENTS = 'communicator/ADD_ALL_ADDITIONAL_RECIPIENTS';
export const ADD_ALL_ADDITIONAL_GROUPS = 'communicator/ADD_ALL_ADDITIONAL_GROUPS';
export const ADD_ALL_ADDITIONAL_SAVED_SEARCHES = 'communicator/ADD_ALL_ADDITIONAL_SAVED_SEARCHES';
export const ADD_ALL_ADDITIONAL_SITES = 'communicator/ADD_ALL_ADDITIONAL_SITES';

export const DELETE_RECIPIENT_REQUEST = 'communicator/DELETE_RECIPIENT_REQUEST';
export const DELETE_RECIPIENT_SUCCESS = 'communicator/DELETE_RECIPIENT_SUCCESS';
export const DELETE_RECIPIENT_FAILURE = 'communicator/DELETE_RECIPIENT_FAILURE';

export const GET_MESSAGE_REQUEST = 'communicator/GET_MESSAGE_REQUEST';
export const GET_MESSAGE_SUCCESS = 'communicator/GET_MESSAGE_SUCCESS';
export const GET_MESSAGE_FAILURE = 'communicator/GET_MESSAGE_FAILURE';

export const GET_MESSAGE_RECIPIENTS_REQUEST = 'communicator/GET_MESSAGE_RECIPIENTS_REQUEST';
export const GET_MESSAGE_RECIPIENTS_SUCCESS = 'communicator/GET_MESSAGE_RECIPIENTS_SUCCESS';
export const GET_MESSAGE_RECIPIENTS_FAILURE = 'communicator/GET_MESSAGE_RECIPIENTS_FAILURE';

export const GET_MANAGED_RECIPIENTS_REQUEST = 'communicator/GET_MANAGED_RECIPIENTS_REQUEST';
export const GET_MANAGED_RECIPIENTS_SUCCESS = 'communicator/GET_MANAGED_RECIPIENTS_SUCCESS';
export const GET_MANAGED_RECIPIENTS_FAILURE = 'communicator/GET_MANAGED_RECIPIENTS_FAILURE';

export const GET_ALSAT_MESSAGE_RECIPIENTS_REQUEST = 'communicator/GET_ALSAT_MESSAGE_RECIPIENTS_REQUEST';
export const GET_ALSAT_MESSAGE_RECIPIENTS_SUCCESS = 'communicator/GET_ALSAT_MESSAGE_RECIPIENTS_SUCCESS';
export const GET_ALSAT_MESSAGE_RECIPIENTS_FAILURE = 'communicator/GET_ALSAT_MESSAGE_RECIPIENTS_FAILURE';

export const GET_MESSAGE_TEMPLATES_REQUEST = 'communicator/GET_MESSAGE_TEMPLATES_REQUEST';
export const GET_MESSAGE_TEMPLATES_SUCCESS = 'communicator/GET_MESSAGE_TEMPLATES_SUCCESS';
export const GET_MESSAGE_TEMPLATES_FAILURE = 'communicator/GET_MESSAGE_TEMPLATES_FAILURE';

export const GET_SCHEDULED_MESSAGE_BY_ID_REQUEST = 'communicator/GET_SCHEDULED_MESSAGE_BY_ID_REQUEST';
export const GET_SCHEDULED_MESSAGE_BY_ID_SUCCESS = 'communicator/GET_SCHEDULED_MESSAGE_BY_ID_SUCCESS';
export const GET_SCHEDULED_MESSAGE_BY_ID_FAILURE = 'communicator/GET_SCHEDULED_MESSAGE_BY_ID_FAILURE';

export const CLEAR_SCHEDULED_MESSAGE = 'communicator/CLEAR_SCHEDULED_MESSAGE';

export const INITIATE_SENDER_RECIPIENTS_FETCH = 'communicator/INITIATE_SENDER_RECIPIENTS_FETCH';
export const GET_ALL_SENDER_RECIPIENTS_SUCCESS = 'communicator/GET_ALL_SENDER_RECIPIENTS_SUCCESS';
export const GET_ALL_SENDER_RECIPIENTS_FAILURE = 'communicator/GET_ALL_SENDER_RECIPIENTS_FAILURE';
export const SET_SHOULD_FETCH_TEMPLATE_RECIPIENTS = 'communicator/SET_SHOULD_FETCH_TEMPLATE_RECIPIENTS';
